import { useInfiniteQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';

export const CREATOR_TEMPLATES_QUERY_LIMIT = 15;

const useCreatorTemplates = (creatorId?: string) => {
  const creatorTemplateCacheKey = ['creatorTemplates', creatorId];

  const paginatedQuery = ({ pageParam = 0 }: { pageParam?: number }) => {
    if (!creatorId)
      return Promise.resolve({
        items: [],
        total: 0,
        cursor: 0,
      });
    return BackendService.instance.discover.getCreatorTemplates(
      creatorId,
      CREATOR_TEMPLATES_QUERY_LIMIT,
      pageParam,
    );
  };

  const {
    data: creatorTemplates,
    isFetching: isFetchingTemplates,
    error,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery(creatorTemplateCacheKey, paginatedQuery, {
    getNextPageParam: lastPage => lastPage.cursor,
    staleTime: 1000 * 60 * 5,
  });

  return {
    items: creatorTemplates,
    error,
    isLoading: isFetchingTemplates,
    isFetchingMore: isFetchingNextPage,
    canFetchMore: hasNextPage,
    fetchMore: fetchNextPage,
  };
};

export default useCreatorTemplates;
